import {z} from 'zod'

import {tzDateFromIso} from 'src/api/zod-helpers'

export const DocumentRawSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    original_filename: z.string(),
    content_type: z.string(),
    size_bytes: z.number().int(),
    created_at: z.string(),
})

export type DocumentRaw = z.infer<typeof DocumentRawSchema>

export const DocumentSchema = DocumentRawSchema.transform((raw) => ({
    ...raw,
    created_at: tzDateFromIso.parse(raw.created_at),
}))

export type Document = z.infer<typeof DocumentSchema>

export const CreateDocumentRequestSchema = z.object({
    name: z.string().min(1),
})

export type CreateDocumentRequest = z.infer<typeof CreateDocumentRequestSchema>

export const RenameDocumentRequestSchema = z.object({
    name: z.string().min(1),
})

export type RenameDocumentRequest = z.infer<typeof RenameDocumentRequestSchema>
